
import { Component, Vue } from 'vue-property-decorator';

import Form18ProcessHeader from "@/components/process/Form18/components/Form18ProcessHeader.vue";
import { form18StatusInfoType } from '@/types/Information/Form18';

@Component({
    components:{
        Form18ProcessHeader
    }
})
export default class CancelSubmitForm18 extends Vue {

    stepsCompleted = {} as form18StatusInfoType;  
    mountedData = false;     

    mounted() {

        this.mountedData = false;        

        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;                   
    }    

    public done() {
        this.$router.push({name: "dashboard" }) 
    }
}
